var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClipboardCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10 1c-.8 0-1.37.56-1.65 1.26H3V18h14V2.26h-5.35C11.37 1.56 10.8 1 10 1m0 1.26c.35 0 .64.28.64.63v.63h1.9v1.26H7.46V3.52h1.91v-.63c0-.35.29-.63.64-.63M4.27 3.52h1.91v2.52h7.64V3.52h1.9v13.22H4.28zm9.1 4.58-4 3.96-2.1-2.07-.9.9 2.54 2.53.45.43.46-.43L14.28 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClipboardCheckSolid);
export default ForwardRef;